<template>
  <div :class="[ns.b(), ...nss]">
    <slot v-if="!vertical" />
  </div>
</template>

<script lang="ts" setup>
import { computed, useSlots } from 'vue'
import { useNamespace } from '@xzx-design/hooks'
import { dividerProps } from './divider'

defineOptions({
  name: 'XzxDivider',
})

const props = defineProps(dividerProps)

const ns = useNamespace('divider')

const slots = useSlots()

const slotsDefault = computed(() => slots?.default?.()[0]?.children)

const nss = computed(() => [
  slotsDefault.value && !props.vertical && ns.is('text'),
  slotsDefault.value &&
    props?.contentPosition &&
    !props.vertical &&
    ns.is(`content-${props?.contentPosition}`),
  props?.dashed && ns.is('dashed'),
  props?.vertical && ns.is('vertical'),
  props?.margin && ns.is('margin'),
])
</script>
